import CreateDisclaimer from 'components/pages/create/create_disclaimer/create_disclaimer'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    countryCode: state.country.country_code,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateDisclaimer)
